import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { UseCase } from '@digibricks/core';
export var PIN_CLASS_ANNOUNCEMENT_USE_CASE = 'PIN_CLASS_ANNOUNCEMENT_USE_CASE';
export var PinClassAnnouncementUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(PinClassAnnouncementUseCase, _UseCase);

  var _super = _createSuper(PinClassAnnouncementUseCase);

  function PinClassAnnouncementUseCase(repository) {
    var _this;

    _classCallCheck(this, PinClassAnnouncementUseCase);

    _this = _super.call(this);
    _this.repository = repository;
    return _this;
  }

  _createClass(PinClassAnnouncementUseCase, [{
    key: "buildUseCase",
    value: function buildUseCase(input) {
      return this.repository.pin(input.classId, input.id, input.pinned, input.version);
    }
  }]);

  return PinClassAnnouncementUseCase;
}(UseCase);